interface NavigatorWithUserAgentData extends Navigator {
  userAgentData?: { mobile: boolean };
}

const MOBILE_OR_TABLET_UA_REGEX = /Android|iPhone|iPad|iPod|Mobile|Tablet|Silk|Kindle|PlayBook|BlackBerry|Opera Mini|IEMobile/i;

/**
 * Whether the app is running in a browser on a computer (not a phone or tablet).
 * Decides whether dashboard users land on the merchant dashboard or the regular app after login.
 */
export const isDesktopDevice = (): boolean => {
  if (typeof navigator === "undefined") {
    return false;
  }

  const nav = navigator as NavigatorWithUserAgentData;
  const userAgent = nav.userAgent || "";

  // iPadOS reports a desktop Mac user agent; touch support is the only reliable tell.
  const isIPadOS = /Macintosh/i.test(userAgent) && nav.maxTouchPoints > 1;
  if (isIPadOS) {
    return false;
  }

  // `userAgentData.mobile` is false for Android tablets, so the UA regex still runs after it.
  if (nav.userAgentData?.mobile) {
    return false;
  }

  return !MOBILE_OR_TABLET_UA_REGEX.test(userAgent);
};
